<template>
  <div class="contents">
    <div class="container-fluid">
      <InvoicePageHeader title="Customer Invoice">
        <template #actions>
          <router-link to="/invoice/create" class="btn px-15 btn-primary text-white">
            <i class="fas fa-file-invoice"></i> Buat Invoice
          </router-link>
        </template>
      </InvoicePageHeader>

      <div class="row">
        <div class="col-lg-4">
          <div class="inv-panel">
            <div class="inv-panel__head"><i class="fas fa-user-plus"></i> Tambah customer</div>
            <div class="inv-panel__body">
              <div class="form-group">
                <label class="inv-form-label">Nama</label>
                <input v-model="newCust.name" class="form-control" placeholder="Nama lengkap">
              </div>
              <div class="form-group">
                <label class="inv-form-label">WhatsApp</label>
                <input v-model="newCust.phone" class="form-control" placeholder="628…">
              </div>
              <div class="form-group">
                <label class="inv-form-label">Email</label>
                <input v-model="newCust.email" type="email" class="form-control" placeholder="opsional">
              </div>
              <button type="button" class="btn btn-primary btn-block" :disabled="saving" @click="create">
                {{ saving ? 'Menyimpan…' : 'Simpan customer' }}
              </button>
            </div>
          </div>

          <div class="inv-panel">
            <div class="inv-panel__head"><i class="fas fa-address-book"></i> Import kontak</div>
            <div class="inv-panel__body">
              <p class="small text-muted">Masukkan ID kontak StarSender, pisahkan koma.</p>
              <input v-model="contactIds" class="form-control mb-3" placeholder="contoh: 101, 102, 103">
              <button type="button" class="btn btn-outline-primary btn-block" @click="importContacts">Import</button>
            </div>
          </div>
        </div>

        <div class="col-lg-8">
          <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
            <div class="inv-toolbar">
              <div class="inv-search">
                <i class="fas fa-search"></i>
                <input v-model="search" type="text" class="form-control" placeholder="Cari nama, WA, email…">
              </div>
              <span class="text-muted small">{{ filteredCustomers.length }} customer</span>
            </div>

            <div v-if="loading" class="text-center py-5">
              <div class="spinner-border text-primary"></div>
            </div>
            <div v-else-if="filteredCustomers.length === 0" class="inv-empty">
              <div class="inv-empty__icon"><i class="fas fa-users"></i></div>
              <h5>Belum ada customer</h5>
              <p>Tambahkan customer agar pembuatan invoice lebih cepat.</p>
            </div>
            <div v-else class="inv-table-wrap">
              <table class="table inv-table mb-0">
                <thead>
                  <tr>
                    <th>Nama</th>
                    <th>WhatsApp</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="c in filteredCustomers" :key="c.id">
                    <td><strong>{{ c.name }}</strong></td>
                    <td>{{ c.phone || '—' }}</td>
                    <td>{{ c.email || '—' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import InvoicePageHeader from '@/components/invoice/InvoicePageHeader.vue';
import '@/assets/invoice-module.css';

export default {
  components: { InvoicePageHeader },
  data() {
    return {
      customers: [],
      newCust: { name: '', phone: '', email: '' },
      contactIds: '',
      search: '',
      loading: true,
      saving: false
    };
  },
  computed: {
    filteredCustomers() {
      const q = (this.search || '').trim().toLowerCase();
      if (!q) return this.customers;
      return this.customers.filter(c => {
        return [c.name, c.phone, c.email].some(v => (v || '').toLowerCase().includes(q));
      });
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      axios.get('invoice/customers')
        .then(r => { this.customers = r.data.data.customers || []; })
        .finally(() => { this.loading = false; });
    },
    create() {
      if (!this.newCust.name.trim()) {
        this.$toast.error('Nama wajib diisi');
        return;
      }
      this.saving = true;
      axios.post('invoice/customers', this.newCust)
        .then(() => {
          this.$toast.success('Customer ditambahkan');
          this.newCust = { name: '', phone: '', email: '' };
          this.load();
        })
        .catch(e => this.$toast.error(e.response?.data?.message || 'Gagal'))
        .finally(() => { this.saving = false; });
    },
    importContacts() {
      const ids = this.contactIds.split(',').map(s => parseInt(s.trim(), 10)).filter(Boolean);
      if (!ids.length) {
        this.$toast.error('Masukkan minimal satu ID kontak');
        return;
      }
      axios.post('invoice/customers/import-contact', { contact_ids: ids })
        .then(() => { this.$toast.success('Import berhasil'); this.contactIds = ''; this.load(); })
        .catch(e => this.$toast.error(e.response?.data?.message || 'Gagal import'));
    }
  }
};
</script>
